module.exports = __webpack_public_path__ + "static/media/google-play.36f3a32f.svg";